import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'English',
    resources: {
      Afrikaans: {
        translation: {
          Next: "Volgende",
          Submit: "Indien",
          Back: "Terug",
          EnterDetail: "Voer asseblief u besonderhede in:",
          EnterEmail: "Voer e-posadres in",
          EnterMobileNumber: "Voer selfoonnommer in",
          TermsCondition: "Ek stem in tot die diensbepalings en privaatheidsbeleid",
          EmptyMsg: "E-pos / selfoon kan nie leeg wees nie. Probeer weer!",
          Least: "Minste",
          Most: "Meeste",
          Set: "Stel",
          Of: "van",
          MaxDiffSelectMsg: "Kies asseblief die minste en meeste item vir elke stel van vrae",
          Minimum_Validation_Msg: "Kies asseblief ten minste",
          Maximum_Validation_Msg: "Kies asseblief maksimum",
          Option: "opsies",
          WrongCredantialMsg: "Dit lyk of daar 'n probleem met jou e-pos of telefoonnommer is - Kontak asseblief ondersteuning by flexicollect-support@eolasinternational.com",
          MissionNotAvailalble: "Jammer hierdie missie is nie meer beskikbaar nie",
          LimitBetweenChar: "Antwoord asseblief tussen",
          LimitWithChar: "Antwoord asseblief met",
          LimitWithinChar: "Antwoord asseblief binne",
          Characters: "Karakters",
          And: "en",
          Or: "of meer",
          NumericValidationMsg: "Voer asseblief slegs numeriese waarde in",
          ValidEmailMsg: "Verskaf asseblief 'n geldige e-pos adres",
          AlphabetValidationMsg: "Voer asseblief slegs alfabetwaarde in",
          AnswerValidation: "Beantwoord asseblief hierdie vraag",
          ServerError: "Bedienerfout het voorgekom met die indiening van die vraelys",
          SurveySubmitted: "Vraelys suksesvol ingedien",
          Cancel: "kanselleer",
          Ok: "OK",
          VideoLengthError : "Video duration should not be more then 3 minute"
        }
      },
      Arabic: {
        translation: {
          Next: "التالي",
          Submit: "إرسال",
          Back: "خلف",
          EnterDetail: "الرجاء إدخال التفاصيل الخاصة بك:",
          EnterEmail: "أدخل البريد الإلكتروني",
          EnterMobileNumber: "أدخل رقم الجوال",
          TermsCondition: "أوافق على شروط الخدمة وسياسة الخصوصية",
          EmptyMsg: "لا يمكن أن يكون البريد الإلكتروني / الجوال فارغًا. حاول ثانية!",
          Least: "الأدنى",
          Most: "الأكثر",
          Set: "مجموعة",
          Of: "من",
          MaxDiffSelectMsg: "يرجى اختيار العنصر الأقل والأكثر لكل مجموعة من الأسئلة",
          Minimum_Validation_Msg: "الرجاء تحديد الحد الأدنى",
          Maximum_Validation_Msg: "الرجاء تحديد الحد الأقصى",
          Option: "خيارات",
          WrongCredantialMsg: "يبدو أن هناك مشكلة في بريدك الإلكتروني أو رقم هاتفك - يرجى الاتصال بالدعم على flexicollect-support@eolasinternational.com",
          MissionNotAvailalble: "آسف هذه المهمة لم تعد متوفرة",
          LimitBetweenChar: "يرجى الإجابة بين",
          LimitWithChar: "يرجى الإجابة مع",
          LimitWithinChar: "يرجى الإجابة في الداخل",
          Characters: "الشخصيات",
          And: "و",
          Or: "او اكثر",
          NumericValidationMsg: "الرجاء إدخال قيمة رقمية فقط",
          ValidEmailMsg: "يرجى إدخال البريد الإلكتروني الصحيح",
          AlphabetValidationMsg: "الرجاء إدخال قيمة الحروف الهجائية فقط",
          AnswerValidation: "الرجاء الإجابة على هذا السؤال",
          ServerError: "حدث خطأ في الخادم أثناء إرسال الاستبيان",
          SurveySubmitted: "تم إرسال الاستبيان بنجاح",
          Cancel: "إلغاء",
          Ok: "موافق",
          VideoLengthError : "Video duration should not be more then 3 minute"
        }
      },
      Chinese: {
        translation: {
          Next: "下一个",
          Submit: "提交",
          Back: "后退",
          EnterDetail: "请输入您的详细信息：",
          EnterEmail: "请输入电邮地址",
          EnterMobileNumber: "输入手机号码",
          TermsCondition: "我同意服务条款和隐私政策",
          EmptyMsg: "邮箱/手机不能为空。再试一次！",
          Least: "最小",
          Most: "最大",
          Set: "集",
          Of: "的",
          MaxDiffSelectMsg: "请为所有问题集选择最小和最大项目",
          Minimum_Validation_Msg: "请选择最小值",
          Maximum_Validation_Msg: "请选择最大值",
          Option: "选项",
          WrongCredantialMsg: "您的电子邮件或电话号码似乎有问题 - 请联系支持人员: flexicollect-support@eolasinternational.com",
          MissionNotAvailalble: "抱歉，此任务不再可用",
          LimitBetweenChar: "请回答之间",
          LimitWithChar: "请回答",
          LimitWithinChar: "请在以下范围内回答",
          Characters: "文本字符",
          And: "和",
          Or: "或者更多",
          NumericValidationMsg: "请仅输入数值",
          ValidEmailMsg: "请输入有效电子邮件",
          AlphabetValidationMsg: "请仅输入字母值",
          AnswerValidation: "请回答这个问题",
          ServerError: "提交调查问卷时服务器发生错误",
          SurveySubmitted: "调查问卷提交成功",
          Cancel: "取消",
          Ok: "确定",
          VideoLengthError : "Video duration should not be more then 3 minute"
        }
      },
      Dutch: {
        translation: {
          Next: "Volgende",
          Submit: "Verzend",
          Back: "Terug",
          EnterDetail: "Vul je gegegevens in:",
          EnterEmail: "E-mail adres",
          EnterMobileNumber: "Telefoonnummer mobiel",
          TermsCondition: "Ik ga akkoord met de Servicevoorwaarden en het Privacybeleid",
          EmptyMsg: "E-mail / Mobiel moet ingevuld worden. Probeer nogmaals!",
          Least: "Minst",
          Most: "Meest",
          Set: "Stel in",
          Of: "van",
          MaxDiffSelectMsg: "Selecteer de minst en meest gekozen items voor alle vragenreeksen.",
          Minimum_Validation_Msg: "Selecteer minimaal",
          Maximum_Validation_Msg: "Selecteer maximaal",
          Option: "opties",
          WrongCredantialMsg: "Er lijkt een probleem te zijn met het e-mail adres of telefoonnummer - Neem alsjeblieft contact op met de klantenservice via flexicollect-support@eolasinternational.com",
          MissionNotAvailalble: "Sorry, deze missie is niet langer beschikbaar",
          LimitBetweenChar: "Antwoord alsjeblieft met tussen de",
          LimitWithChar: "Antwoord alsjeblieft met",
          LimitWithinChar: "Antwoord alsjeblieft met minder dan",
          Characters: "karakters",
          And: "en",
          Or: "of meer",
          NumericValidationMsg: "Geef alleen cijfers op alsjeblieft",
          ValidEmailMsg: "Geef een geldig e-mail adres op alsjeblieft",
          AlphabetValidationMsg: "Voer alleen alfabetische waarden in",
          AnswerValidation: "Beantwoord deze vraag alsjeblieft",
          ServerError: "Er trad een serverfout op tijdens het verzenden van de vragenlijst",
          SurveySubmitted: "Vragenlijst succesvol verzonden",
          Cancel: "Annuleren",
          Ok: "OK",
          VideoLengthError : "Video duration should not be more then 3 minute"
        }
      },
      English: {
        translation: {
          Next: "Next",
          Submit: "Submit",
          Back: "Back",
          EnterDetail: "Please Enter your Details:",
          EnterEmail: "Enter Email",
          EnterMobileNumber: "Enter Mobile Number",
          TermsCondition: "I agree to the Terms of Service and Privacy Policy",
          EmptyMsg: "Email / Mobile cannot be empty. Try again!",
          Least: "Least",
          Most: "Most",
          Set: "Set",
          Of: "Of",
          MaxDiffSelectMsg: "Please select least and most item for all set of question",
          Minimum_Validation_Msg: "Please select minimum",
          Maximum_Validation_Msg: "Please select maximum",
          Option: "options",
          WrongCredantialMsg: "There seems to be an issue with your email or phone number - Please contact support at flexicollect-support@eolasinternational.com",
          MissionNotAvailalble: "Sorry this mission is no longer available",
          LimitBetweenChar: "Please answer between",
          LimitWithChar: "Please answer with",
          LimitWithinChar: "Please answer within",
          Characters: "characters",
          And: "and",
          Or: "or more",
          NumericValidationMsg: "Please enter numeric value only",
          ValidEmailMsg: "Please enter a valid email",
          AlphabetValidationMsg: "Please enter alphabets value only",
          AnswerValidation: "Please answer this question",
          ServerError: "Server error occurred in submitting the survey",
          SurveySubmitted: "Survey Submitted Successfully",
          Cancel: "Cancel",
          Ok: "OK",
          VideoLengthError : "Video duration should not be more then 3 minute"
        }
      },
      French: {
        translation: {
          Next: "Suivant",
          Submit: "Soumettre",
          Back: "Back",
          EnterDetail: "Veuillez entrer vos coordonnées :",
          EnterEmail: "Entrez l'e-mail",
          EnterMobileNumber: "Entrez le numéro de portable",
          TermsCondition: "J'accepte les conditions d'utilisation et la politique de confidentialité",
          EmptyMsg: "Email / Mobile ne peut pas être vide. Essayer à nouveau!",
          Least: "Le moins",
          Most: "Le plus",
          Set: "Ensemble",
          Of: "de",
          MaxDiffSelectMsg: "Veuillez sélectionner l'option la moins et la plus choisie pour chaque ensemble de questions.",
          Minimum_Validation_Msg: "Veuillez sélectionner un minimum",
          Maximum_Validation_Msg: "Veuillez sélectionner un maximum",
          Option: "Choix",
          WrongCredantialMsg: "Il semble y avoir un problème avec votre email ou votre numéro de téléphone - Veuillez contacter le support à flexicollect-support@eolasinternational.com",
          MissionNotAvailalble: "Désolé, cette mission n'est plus disponible",
          LimitBetweenChar: "Veuillez répondre entre",
          LimitWithChar: "Veuillez répondre avec",
          LimitWithinChar: "Veuillez répondre en",
          Characters: "caractères",
          And: "et",
          Or: "ou plus",
          NumericValidationMsg: "Veuillez saisir une valeur numérique uniquement",
          ValidEmailMsg: "Veuillez saisir une adresse électronique valide",
          AlphabetValidationMsg: "Veuillez saisir uniquement une valeur alphabétique",
          AnswerValidation: "Veuillez répondre à cette question",
          ServerError: "Une erreur de serveur s'est produite lors de la soumission de l'enquête",
          SurveySubmitted: "L'enquête a été soumise avec succès",
          Cancel: "Annuler",
          Ok: "OK",
          VideoLengthError : "Video duration should not be more then 3 minute"
        }
      },
      German: {
        translation: {
          Next: "Weiter",
          Submit: "Abschicken",
          Back: "Zurück",
          EnterDetail: "Bitte geben Sie Ihre Details ein:",
          EnterEmail: "E-Mail eingeben",
          EnterMobileNumber: "Handynummer eingeben",
          TermsCondition: "Ich stimme den Nutzungsbedingungen und der Datenschutzrichtlinie zu",
          EmptyMsg: "Email / Mobile kann nicht leer sein. Versuchen Sie es erneut!",
          Least: "Am wenigsten",
          Most: "Am meisten",
          Set: "Gruppe",
          Of: "von",
          MaxDiffSelectMsg: "Bitte wählen Sie das Element mit der geringsten und der größten Bewertung für alle Fragengruppen.",
          Minimum_Validation_Msg: "Bitte wählen Sie das Minimum",
          Maximum_Validation_Msg: "Bitte wählen Sie das Maximum",
          Option: "Optionen",
          WrongCredantialMsg: "Es scheint ein Problem mit Ihrer E-Mail oder Telefonnummer zu geben - Bitte kontaktieren Sie den Support unter flexicollect-support@eolasinternational.com",
          MissionNotAvailalble: "Diese Mission ist leider nicht mehr verfügbar",
          LimitBetweenChar: "Bitte antworten Sie zwischen",
          LimitWithChar: "Bitte antworten Sie mit",
          LimitWithinChar: "Bitte antworten Sie innerhalb",
          Characters: "Zeichen",
          And: "und",
          Or: "oder mehr",
          NumericValidationMsg: "Bitte nur numerische Werte eingeben",
          ValidEmailMsg: "Bitte geben Sie eine gültige E-Mail ein",
          AlphabetValidationMsg: "Bitte geben Sie nur den alphabetischen Wert ein",
          AnswerValidation: "Bitte beantworten Sie diese Frage",
          ServerError: "Bei der Übermittlung der Umfrage ist ein Serverfehler aufgetreten",
          SurveySubmitted: "Umfrage erfolgreich abgeschickt",
          Cancel: "Abbrechen",
          Ok: "OK",
          VideoLengthError : "Video duration should not be more then 3 minute"
        }
      },
      Greek: {
        translation: {
          Next: "Next",
          Submit: "Υποβολή",
          Back: "Πίσω",
          EnterDetail: "Παρακαλώ εισάγετε το λεπτομερειών σας:",
          EnterEmail: "εισάγετε Email",
          EnterMobileNumber: "εισάγετε τον αριθμό κινητού",
          TermsCondition: "I agree to the Terms of Service and Privacy Policy",
          EmptyMsg: "Email / Mobile cannot be empty. Try again!",
          Least: "Ελάχιστο",
          Most: "Μέγιστο",
          Set: "Ορισμός",
          Of: "από",
          MaxDiffSelectMsg: "Παρακαλώ επιλέξτε το ελάχιστο και το μέγιστο στοιχείο για όλες τις ερωτήσεις",
          Minimum_Validation_Msg: "Παρακαλώ επιλέξτε το ελάχιστο",
          Maximum_Validation_Msg: "Παρακαλώ επιλέξτε το μέγιστο",
          Option: "επιλογές",
          WrongCredantialMsg: "There seems to be an issue with your email or phone number - Please contact support at flexicollect-support@eolasinternational.com",
          MissionNotAvailalble: "Sorry this mission is no longer available",
          LimitBetweenChar: "Please answer between",
          LimitWithChar: "Please answer with",
          LimitWithinChar: "Please answer within",
          Characters: "characters",
          And: "and",
          Or: "or more",
          NumericValidationMsg: "Please enter numeric value only",
          ValidEmailMsg: "Παρακαλώ εισάγετε μια έγκυρη διεύθυνση ηλεκτρονικού ταχυδρομείου",
          AlphabetValidationMsg: "Please enter alphabets value only",
          AnswerValidation: "Please answer this question",
          ServerError: "Server error occurred in submitting the survey",
          SurveySubmitted: "Survey Submitted Successfully",
          Cancel: "Άκυρο",
          Ok: "ΟΚ",
          VideoLengthError : "Video duration should not be more then 3 minute"
        }
      },
      Hindi: {
        translation: {
          Next: "अगला",
          Submit: "उत्तर जमा करें",
          Back: "पीछे",
          EnterDetail: "कृपया अपना विवरण दर्ज करें:",
          EnterEmail: "ईमेल पता दर्ज करें",
          EnterMobileNumber: "मोबाइल नंबर दर्ज करें",
          TermsCondition: "मैं सेवा की शर्तों और गोपनीयता नीति से सहमत हूं",
          EmptyMsg: "ईमेल/मोबाइल खाली नहीं हो सकता. पुनः प्रयास करें!",
          Least: "सबसे कम",
          Most: "सबसे अधिक",
          Set: "सेट",
          Of: "का",
          MaxDiffSelectMsg: "कृपया सभी सेट के प्रश्न के लिए सबसे कम और सबसे अधिक आइटम का चयन करें",
          Minimum_Validation_Msg: "कम से कम चुनें",
          Maximum_Validation_Msg: "कृपया अधिकतम चुनें",
          Option: "विकल्प",
          WrongCredantialMsg: "ऐसा प्रतीत होता है कि आपके ईमेल या फ़ोन नंबर में कोई समस्या है - कृपया flexicollect-support@eolasinternational.com पर सहायता से संपर्क करें",
          MissionNotAvailalble: "क्षमा करें यह मिशन अब उपलब्ध नहीं है",
          LimitBetweenChar: "कृपया बीच में उत्तर दें",
          LimitWithChar: "कृपया उत्तर दें",
          LimitWithinChar: "कृपया भीतर उत्तर दें",
          Characters: "पाठ वर्ण",
          And: "और",
          Or: "या अधिक",
          NumericValidationMsg: "कृपया केवल संख्यात्मक मान दर्ज करें",
          ValidEmailMsg: "कृपया एक मान्य ईमेल पता प्रविष्ट करें",
          AlphabetValidationMsg: "कृपया केवल वर्णानुक्रमिक मान दर्ज करें",
          AnswerValidation: "कृपया इस प्रश्न का उत्तर दें",
          ServerError: "सर्वेक्षण सबमिट करने में सर्वर त्रुटि हुई",
          SurveySubmitted: "प्रश्नावली सफलतापूर्वक प्रस्तुत की गई",
          Cancel: "रद्द करें",
          Ok: "ठीक है",
          VideoLengthError : "Video duration should not be more then 3 minute"
        }
      },
      Indonesian: {
        translation: {
          Next: "Berikutnya",
          Submit: "Masukan",
          Back: "Kembali",
          EnterDetail: "Silakan Masukkan Detail Anda:",
          EnterEmail: "Masukkan alamat email",
          EnterMobileNumber: "Masukkan Nomor Ponsel",
          TermsCondition: "Saya menyetujui Ketentuan Layanan dan Kebijakan Privasi",
          EmptyMsg: "Email/Hp wajib diisi. Coba lagi!",
          Least: "Paling Sedikit",
          Most: "Paling Banyak",
          Set: "Kelompok",
          Of: "dari",
          MaxDiffSelectMsg: "Silakan pilih item paling sedikit dan paling banyak untuk semua set pertanyaan",
          Minimum_Validation_Msg: "Silakan pilih minimum",
          Maximum_Validation_Msg: "Silakan pilih maksimum",
          Option: "pilihan",
          WrongCredantialMsg: "Tampaknya ada masalah dengan email atau nomor telepon Anda - Silakan hubungi dukungan di flexicollect-support@eolasinternational.com",
          MissionNotAvailalble: "Maaf misi ini tidak lagi tersedia",
          LimitBetweenChar: "Please anTolong jawab di antara",
          LimitWithChar: "Tolong jawab dengan",
          LimitWithinChar: "Tolong jawab di dalam",
          Characters: "karakter",
          And: "dan",
          Or: "atau lebih",
          NumericValidationMsg: "Harap masukkan nilai numerik saja",
          ValidEmailMsg: "tolong masukkan email yang benar",
          AlphabetValidationMsg: "Silakan masukkan nilai huruf saja",
          AnswerValidation: "Tolong jawab pertanyaan ini",
          ServerError: "Terjadi kesalahan server saat mengirimkan survei",
          SurveySubmitted: "Survei Berhasil Dikirim",
          Cancel: "Batal",
          Ok: "OK",
          VideoLengthError : "Video duration should not be more then 3 minute"
        }
      },
      Italian: {
        translation: {
          Next: "successivo",
          Submit: "Inviare",
          Back: "Indietro",
          EnterDetail: "Inserisci i tuoi dettagli:",
          EnterEmail: "Inserisci l'email",
          EnterMobileNumber: "Inserisci il numero di cellulare",
          TermsCondition: "Accetto i Termini di servizio e l'Informativa sulla privacy",
          EmptyMsg: "L'e-mail/il cellulare non possono essere vuoti. Riprova!",
          Least: "Minimo",
          Most: "Massimo",
          Set: "Set",
          Of: "di",
          MaxDiffSelectMsg: "Seleziona l'elemento minimo e massimo per tutti i set di domande",
          Minimum_Validation_Msg: "Seleziona il minimo",
          Maximum_Validation_Msg: "Seleziona il massimo",
          Option: "opzioni",
          WrongCredantialMsg: "Sembra che ci sia un problema con il tuo indirizzo email o numero di telefono: contatta l'assistenza all'indirizzo flexicollect-support@eolasinternational.com",
          MissionNotAvailalble: "Siamo spiacenti, questa missione non è più disponibile",
          LimitBetweenChar: "Per favore rispondi tra",
          LimitWithChar: "Per favore rispondi con",
          LimitWithinChar: "Per favore rispondi entro",
          Characters: "caratteri",
          And: "e",
          Or: "o più",
          NumericValidationMsg: "Inserisci solo un valore numerico",
          ValidEmailMsg: "Inserisci una email valida",
          AlphabetValidationMsg: "Inserisci solo il valore alfabetico",
          AnswerValidation: "Per favore rispondi a questa domanda",
          ServerError: "Si è verificato un errore del server durante l'invio del questionario",
          SurveySubmitted: "Questionario inviato con successo",
          Cancel: "Annulla",
          Ok: "OK",
          VideoLengthError : "Video duration should not be more then 3 minute"
        }
      },
      Japanese: {
        translation: {
          Next: "次",
          Submit: "送信",
          Back: "戻る",
          EnterDetail: "詳細を入力してください:",
          EnterEmail: "メールアドレスを入力して",
          EnterMobileNumber: "携帯電話番号を入力してください",
          TermsCondition: "利用規約とプライバシーポリシーに同意します",
          EmptyMsg: "電子メール/携帯電話を空にすることはできません。もう一度やり直してください！",
          Least: "最低",
          Most: "最高",
          Set: "セット",
          of: "の",
          MaxDiffSelectMsg: "すべてのセットの質問について、最低と最高のアイテムを選択してください",
          Minimum_Validation_Msg: "最小を選択してください",
          Maximum_Validation_Msg: "最大値を選択してください",
          Option: "オプション",
          WrongCredantialMsg: "電子メールまたは電話番号に問題があるようです - サポート (flexicollect-support@eolasinternational.com) までご連絡ください。",
          MissionNotAvailalble: "申し訳ありませんが、このミッションは利用できなくなりました",
          LimitBetweenChar: "の間で答えてください",
          LimitWithChar: "と答えてください",
          LimitWithinChar: "以内にご回答ください",
          Characters: "テキスト文字",
          And: "そして",
          Or: "以上",
          NumericValidationMsg: "数値のみを入力してください",
          ValidEmailMsg: "正しいメールアドレスを入力してください",
          AlphabetValidationMsg: "アルファベット値のみを入力してください",
          AnswerValidation: "この質問に答えてください",
          ServerError: "アンケート送信時にサーバーエラーが発生しました",
          SurveySubmitted: "アンケートは正常に送信されました",
          Cancel: "キャンセル",
          Ok: "わかった",
          VideoLengthError : "Video duration should not be more then 3 minute"
        }
      },
      Malay: {
        translation: {
          Next: "Seterusnya",
          Submit: "Hantar",
          Back: "balikBack",
          EnterDetail: "Sila Masukkan Butiran anda:",
          EnterEmail: "Masukkan alamat email",
          EnterMobileNumber: "Masukkan Nombor Mudah Alih",
          TermsCondition: "Saya bersetuju menerima Syarat Perkhidmatan dan Dasar Privasi",
          EmptyMsg: "E-mel / Mudah Alih tidak boleh kosong. Cuba lagi!",
          Least: "Terendah",
          Most: "Kebanyakan",
          Set: "Kumpulan",
          Of: "daripada",
          MaxDiffSelectMsg: "Sila pilih item terendah dan tertinggi untuk semua set soalan",
          Minimum_Validation_Msg: "Sila pilih minimum",
          Maximum_Validation_Msg: "Sila pilih maksimum",
          Option: "pilihan",
          WrongCredantialMsg: "Nampaknya terdapat masalah dengan e-mel atau nombor telefon anda - Sila hubungi sokongan di flexicollect-support@eolasinternational.com",
          MissionNotAvailalble: "Maaf misi ini tidak tersedia lagi",
          LimitBetweenChar: "Sila jawab antara",
          LimitWithChar: "Sila jawab dengan",
          LimitWithinChar: "Sila jawab dalam",
          Characters: "Aksara",
          And: "dan",
          Or: "atau lebih",
          NumericValidationMsg: "Sila masukkan nilai angka sahaja",
          ValidEmailMsg: "Sila masukkan e-mel yang sah",
          AlphabetValidationMsg: "Sila masukkan nilai abjad sahaja",
          AnswerValidation: "Sila jawab soalan ini",
          ServerError: "Ralat pelayan berlaku semasa menyerahkan soal selidik",
          SurveySubmitted: "Soal selidik berjaya dihantar",
          Cancel: "Batal",
          Ok: "Baik",
          VideoLengthError : "Video duration should not be more then 3 minute"
        }
      },
      Polish: {
        translation: {
          Next: "Następny",
          Submit: "Prześlij",
          Back: "Wróć",
          EnterDetail: "Proszę podać swoje dane:",
          EnterEmail: "Wprowadź adres e-mail",
          EnterMobileNumber: "Wprowadź numer telefonu komórkowego",
          TermsCondition: "Zgadzam się z Regulaminem świadczenia usług i Polityką prywatności",
          EmptyMsg: "Adres e-mail / telefon komórkowy nie może być pusty. Spróbuj ponownie!",
          Least: "Najwięcej",
          Most: "Most",
          Set: "Zestaw",
          Of: "z",
          MaxDiffSelectMsg: "Proszę wybrać najmniej i najwięcej element dla wszystkich zestawów pytań",
          Minimum_Validation_Msg: "Proszę wybrać minimum",
          Maximum_Validation_Msg: "Proszę wybrać maksimum",
          Option: "opcje",
          WrongCredantialMsg: "Wygląda na to, że wystąpił problem z Twoim adresem e-mail lub numerem telefonu — skontaktuj się z pomocą techniczną pod adresem flexicollect-support@eolasinternational.com",
          MissionNotAvailalble: "Przepraszamy, ta misja nie jest już dostępna",
          LimitBetweenChar: "Proszę odpowiedzieć pomiędzy",
          LimitWithChar: "Proszę o odpowiedź",
          LimitWithinChar: "Proszę o odpowiedź w środku",
          Characters: "Znaki",
          And: "I",
          Or: "albo więcej",
          NumericValidationMsg: "Proszę wprowadzić tylko wartość liczbową",
          ValidEmailMsg: "Proszę podać poprawny adres e-mail",
          AlphabetValidationMsg: "Proszę wprowadzić tylko wartość alfabetyczną",
          AnswerValidation: "Proszę odpowiedzieć na to pytanie",
          ServerError: "Podczas przesyłania kwestionariusza wystąpił błąd serwera",
          SurveySubmitted: "Kwestionariusz przesłany pomyślnie",
          Cancel: "Anuluj",
          Ok: "Dobra",
          VideoLengthError : "Video duration should not be more then 3 minute"
        }
      },
      Portuguese: {
        translation: {
          Next: "Próxima ",
          Submit: "Enviar",
          Back: "Volte",
          EnterDetail: "Por favor insira seus dados:",
          EnterEmail: "Insira o endereço de e-mail",
          EnterMobileNumber: "Digite o número do celular",
          TermsCondition: "Concordo com os Termos de Serviço e Política de Privacidade",
          EmptyMsg: "Email/Celular não pode ficar vazio. Tente novamente!",
          Least: "Mínimo",
          Most: "Máximo",
          Set: "Conjunto",
          Of: "de",
          MaxDiffSelectMsg: "Por favor, selecione o item mínimo e máximo para todos os conjuntos de perguntas",
          Minimum_Validation_Msg: "Por favor, selecione o mínimo",
          Maximum_Validation_Msg: "Por favor, selecione o máximo",
          Option: "opções",
          WrongCredantialMsg: "Parece haver um problema com seu e-mail ou número de telefone. Entre em contato com o suporte em flexicollect-support@eolasinternational.com",
          MissionNotAvailalble: "Desculpe, esta missão não está mais disponível",
          LimitBetweenChar: "Por favor responda entre",
          LimitWithChar: "Por favor responda com",
          LimitWithinChar: "Por favor responda dentro",
          Characters: "caracteres",
          And: "e",
          Or: "ou mais",
          NumericValidationMsg: "Insira apenas o valor numérico",
          ValidEmailMsg: "Por favor digite um email válido",
          AlphabetValidationMsg: "Insira apenas o valor alfabético",
          AnswerValidation: "Por favor responda a esta pergunta",
          ServerError: "Ocorreu um erro no servidor ao enviar o questionário",
          SurveySubmitted: "Questionário enviado com sucesso",
          Cancel: "Cancelar",
          Ok: "OK",
          VideoLengthError : "Video duration should not be more then 3 minute"
        }
      },
      Russian: {
        translation: {
          Next: "следующий",
          Submit: "Разместить",
          Back: "назад",
          EnterDetail: "Пожалуйста, введите свои данные:",
          EnterEmail: "Введите адрес электронной почты",
          EnterMobileNumber: "Введите номер мобильного телефона",
          TermsCondition: "Я согласен с Условиями обслуживания и Политикой конфиденциальности",
          EmptyMsg: "Электронная почта/мобильный телефон не могут быть пустыми. Попробуйте еще раз!",
          Least: "Наименьшее",
          Most: "Наибольшее",
          Set: "Набор",
          Of: "из",
          MaxDiffSelectMsg: "Пожалуйста, выберите наименьший и наибольший элементы для всех наборов вопросов",
          Minimum_Validation_Msg: "Пожалуйста, выберите минимум",
          Maximum_Validation_Msg: "Пожалуйста, выберите максимум",
          Option: "вариантов",
          WrongCredantialMsg: "Кажется, возникла проблема с вашим адресом электронной почты или номером телефона. Обратитесь в службу поддержки по адресу flexicollect-support@eolasinternational.com.",
          MissionNotAvailalble: "Извините, эта миссия больше не доступна",
          LimitBetweenChar: "Пожалуйста, ответьте между",
          LimitWithChar: "Пожалуйста, ответьте с",
          LimitWithinChar: "Пожалуйста, ответьте в течение",
          Characters: "символы",
          And: "и",
          Or: "или больше",
          NumericValidationMsg: "Пожалуйста, введите только числовое значение",
          ValidEmailMsg: "Введите, пожалуйста, действительный адрес электронной почты",
          AlphabetValidationMsg: "Пожалуйста, введите только значение алфавита",
          AnswerValidation: "Пожалуйста, ответьте на этот вопрос",
          ServerError: "Произошла ошибка сервера при отправке опроса",
          SurveySubmitted: "Анкета успешно отправлена",
          Cancel: "Отмена",
          Ok: "хорошо",
          VideoLengthError : "Video duration should not be more then 3 minute"
        }
      },
      Spanish: {
        translation: {
          Next: "Siguiente",
          Submit: "Enviar",
          Back: "Atras",
          EnterDetail: "Por favor ingrese sus datos:",
          EnterEmail: "Ingrese su dirección de correo electrónico",
          EnterMobileNumber: "Ingrese el número de móvil",
          TermsCondition: "Acepto los Términos de servicio y la Política de privacidad",
          EmptyMsg: "El correo electrónico/móvil no puede estar vacío. ¡Intentar otra vez!",
          Least: "Menor",
          Most: "Mayor",
          Set: "conjunto",
          Of: "de",
          MaxDiffSelectMsg: "Por favor selecciona el elemento más pequeño y más grande para todos los conjuntos de preguntas",
          Minimum_Validation_Msg: "Por favor selecciona un mínimo",
          Maximum_Validation_Msg: "Por favor selecciona un máximo",
          Option: "opciones",
          WrongCredantialMsg: "Parece que hay un problema con su correo electrónico o número de teléfono. Comuníquese con el soporte técnico en flexicollect-support@eolasinternational.com.",
          MissionNotAvailalble: "Lo sentimos, esta misión ya no está disponible",
          LimitBetweenChar: "Por favor responda entre",
          LimitWithChar: "Por favor responda con",
          LimitWithinChar: "Por favor responda dentro",
          Characters: "caracteres",
          And: "y",
          Or: "o más",
          NumericValidationMsg: "Por favor ingrese solo el valor numérico",
          ValidEmailMsg: "Por favor introduzca una dirección de correo electrónico válida",
          AlphabetValidationMsg: "Por favor ingrese solo el valor de las letras",
          AnswerValidation: "Por favor responde esta pregunta",
          ServerError: "Se produjo un error del servidor al enviar el cuestionario",
          SurveySubmitted: "Cuestionario enviado exitosamente",
          Cancel: "Cancelar",
          Ok: "Bueno",
          VideoLengthError : "Video duration should not be more then 3 minute"
        }
      },
      Tagalog: {
        translation: {
          Next: "Susunod",
          Submit: "Ipasa",
          Back: "Bumalik",
          EnterDetail: "Pakilagay ang iyong mga detalye:",
          EnterEmail: "Maglagay ng email",
          EnterMobileNumber: "Ilagay ang mobile number",
          TermsCondition: "Sumasang-ayon ako sa Mga Tuntunin ng Serbisyo at Patakaran sa Privacy",
          EmptyMsg: "Hindi maaaring walang laman ang Email / Mobile. Subukan muli!",
          Least: "Pinakamababa",
          Most: "Pinakamataas",
          Set: "Set",
          Of: "ng",
          MaxDiffSelectMsg: "Mangyaring pumili ng pinakamababa at pinakamataas na item para sa lahat ng set ng tanong",
          Minimum_Validation_Msg: "Mangyaring pumili ng minimum",
          Maximum_Validation_Msg: "Mangyaring pumili ng maximum",
          Option: "mga pagpipilian",
          WrongCredantialMsg: "Mukhang may isyu sa iyong email o numero ng telepono - Mangyaring makipag-ugnayan sa suporta sa flexicollect-support@eolasinternational.com",
          MissionNotAvailalble: "Paumanhin, hindi na available ang misyon na ito",
          LimitBetweenChar: "Pakisagot sa pagitan",
          LimitWithChar: "Pakisagot ng",
          LimitWithinChar: "Pakisagot sa loob",
          Characters: "mga karakter",
          And: "at",
          Or: "o higit pang mga",
          NumericValidationMsg: "Mangyaring maglagay ng numerong halaga lamang",
          ValidEmailMsg: "Mangyaring magpasok ng wastong email",
          AlphabetValidationMsg: "Mangyaring ilagay ang halaga ng mga titik lamang",
          AnswerValidation: "Pakisagot ang tanong na ito",
          ServerError: "Nagkaroon ng error sa server sa pagsusumite ng survey",
          SurveySubmitted: "Matagumpay na naisumite ang survey",
          Cancel: "Kanselahin",
          Ok: "Sige",
          VideoLengthError : "Video duration should not be more then 3 minute"
        }
      },
      Thai: {
        translation: {
          Next: "ต่อไป",
          Submit: "ส่ง",
          Back: "กลับ",
          EnterDetail: "กรุณากรอกรายละเอียดของคุณ:",
          EnterEmail: "ป้อนที่อยู่อีเมล",
          EnterMobileNumber: "กรอกหมายเลขโทรศัพท์มือถือ",
          TermsCondition: "ฉันยอมรับข้อกำหนดในการให้บริการและนโยบายความเป็นส่วนตัว",
          EmptyMsg: "อีเมล / มือถือไม่สามารถเว้นว่างได้ ลองอีกครั้ง!",
          Least: "น้อยที่สุด",
          Most: "มากที่สุด",
          Set: "ชุด",
          Of: "ของ",
          MaxDiffSelectMsg: "โปรดเลือกรายการน้อยที่สุดและมากที่สุดสำหรับชุดคำถามทั้งหมด",
          Minimum_Validation_Msg: "โปรดเลือกค่าต่ำสุด",
          Maximum_Validation_Msg: "โปรดเลือกค่าสูงสุด",
          Option: "ตัวเลือก",
          WrongCredantialMsg: "ดูเหมือนว่าจะมีปัญหากับอีเมลหรือหมายเลขโทรศัพท์ของคุณ - โปรดติดต่อฝ่ายสนับสนุนที่ flexicollect-support@eolasinternational.com",
          MissionNotAvailalble: "ขออภัย ภารกิจนี้ไม่สามารถใช้ได้อีกต่อไป",
          LimitBetweenChar: "กรุณาตอบระหว่าง.",
          LimitWithChar: "ช่วยตอบด้วย",
          LimitWithinChar: "กรุณาตอบภายใน.",
          Characters: "อักขระข้อความ",
          And: "และ",
          Or: "หรือมากกว่า",
          NumericValidationMsg: "กรุณากรอกค่าตัวเลขเท่านั้น",
          ValidEmailMsg: "กรุณาใส่อีเมลที่ถูกต้อง",
          AlphabetValidationMsg: "กรุณากรอกค่าตัวอักษรเท่านั้น",
          AnswerValidation: "กรุณาตอบคำถามนี้",
          ServerError: "เกิดข้อผิดพลาดของเซิร์ฟเวอร์ในการส่งแบบสำรวจ",
          SurveySubmitted: "ส่งแบบสำรวจเรียบร้อยแล้ว",
          Cancel: "ยกเลิก",
          Ok: "ตกลง",
          VideoLengthError : "Video duration should not be more then 3 minute"
        }
      },
      Vietnamese: {
        translation: {
          Next: "Kế tiếp",
          Submit: "Nộp",
          Back: "trước",
          EnterDetail: "Vui lòng nhập thông tin chi tiết của bạn:",
          EnterEmail: "Nhập địa chỉ email",
          EnterMobileNumber: "Nhập số điện thoại di động",
          TermsCondition: "Tôi đồng ý với Điều khoản dịch vụ và Chính sách quyền riêng tư",
          EmptyMsg: "Email/Điện thoại di động không được để trống. Thử lại!",
          Least: "Ít nhất",
          Most: "Nhiều nhất",
          Set: "Bộ",
          Of: "của",
          MaxDiffSelectMsg: "Vui lòng chọn mục ít nhất và nhiều nhất cho tất cả các bộ câu hỏi",
          Minimum_Validation_Msg: "Vui lòng chọn ít nhất",
          Maximum_Validation_Msg: "Vui lòng chọn tối đa",
          Option: "tùy chọn",
          WrongCredantialMsg: "Có vẻ như có vấn đề với email hoặc số điện thoại của bạn - Vui lòng liên hệ với bộ phận hỗ trợ tại flexicollect-support@eolasinternational.com",
          MissionNotAvailalble: "Rất tiếc, nhiệm vụ này không còn nữa",
          LimitBetweenChar: "Hãy trả lời giữa",
          LimitWithChar: "Hãy trả lời với",
          LimitWithinChar: "Hãy trả lời trong vòng",
          Characters: "ký tự văn bản",
          And: "Và",
          Or: "hoặc nhiều hơn",
          NumericValidationMsg: "Vui lòng chỉ nhập giá trị số",
          ValidEmailMsg: "Vui lòng nhập email hợp lệ",
          AlphabetValidationMsg: "Vui lòng chỉ nhập giá trị theo bảng chữ cái",
          AnswerValidation: "Hãy trả lời câu hỏi này",
          ServerError: "Đã xảy ra lỗi máy chủ khi gửi khảo sát",
          SurveySubmitted: "Đã gửi khảo sát thành công",
          Cancel: "Hủy bỏ",
          Ok: "Đồng ý",
          VideoLengthError : "Video duration should not be more then 3 minute"
        }
      },
      Urdu: {
        translation: {
          Next: "اگلے",
          Submit: "جمع کرائیں",
          Back: "پیچھے",
          EnterDetail: "براہ کرم اپنی تفصیلات درج کریں:",
          EnterEmail: "ای میل درج کریں۔",
          EnterMobileNumber: "موبائل نمبر درج کریں۔",
          TermsCondition: "میں سروس کی شرائط اور رازداری کی پالیسی سے اتفاق کرتا ہوں۔",
          EmptyMsg: "ای میل/موبائل خالی نہیں ہو سکتا۔ دوبارہ کوشش کریں!",
          Least: "کمترین",
          Most: "زیادہ سے زیادہ",
          Set: "مجموعہ",
          Of: "کا",
          MaxDiffSelectMsg: "براہ کرم ہر سیٹ کے سوال کے لئے کمترین اور زیادہ سے زیادہ آئٹم منتخب کریں",
          Minimum_Validation_Msg: "براہ کرم کم سے کم منتخب کریں",
          Maximum_Validation_Msg: "براہ کرم زیادہ سے زیادہ منتخب کریں",
          Option: "اختیار",
          WrongCredantialMsg: "ایسا لگتا ہے کہ آپ کے ای میل یا فون نمبر میں کوئی مسئلہ ہے - براہ کرم flexicollect-support@eolasinternational.com پر سپورٹ سے رابطہ کریں",
          MissionNotAvailalble: "افسوس کہ یہ مشن اب دستیاب نہیں ہے۔",
          LimitBetweenChar: "براہ کرم درمیان میں جواب دیں۔",
          LimitWithChar: "کے ساتھ جواب دیں۔",
          LimitWithinChar: "براہ کرم اندر جواب دیں۔",
          Characters: "متن کے حروف",
          And: "اور",
          Or: "یا اس سے زیادہ",
          NumericValidationMsg: "براہ کرم صرف عددی قدر درج کریں۔",
          ValidEmailMsg: "ایک درست ای میل درج کریں",
          AlphabetValidationMsg: "براہ کرم صرف حروف تہجی کی قدر درج کریں۔",
          AnswerValidation: "براہ کرم اس سوال کا جواب دیں۔",
          ServerError: "سروے جمع کرانے میں سرور کی خرابی پیش آگئی",
          SurveySubmitted: "سروے کامیابی کے ساتھ جمع کرایا گیا۔",
          Cancel: "منسوخ کریں",
          Ok: "تصدیق کریں",
          VideoLengthError : "Video duration should not be more then 3 minute"
        }
      },
    },
  });

export default i18n;